var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFeatureTopHospitalFilled = function SvgFeatureTopHospitalFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M11.726 4.616c.394 0 .713.32.713.713v2.378a.713.713 0 1 1-1.427 0V5.33c0-.394.32-.713.714-.713",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M9.823 6.518c0-.394.32-.713.714-.713h2.378a.713.713 0 0 1 0 1.427h-2.378a.713.713 0 0 1-.714-.714",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M11.726 3.427a3.091 3.091 0 1 0 0 6.183 3.091 3.091 0 0 0 0-6.183M7.207 6.518a4.518 4.518 0 1 1 9.037 0 4.518 4.518 0 0 1-9.037 0M8.872 14.842a.238.238 0 0 0-.238.237v4.994h6.183V15.08a.238.238 0 0 0-.238-.238H8.872m-1.665.237c0-.92.746-1.664 1.665-1.664h5.707c.92 0 1.665.745 1.665 1.664v5.708c0 .394-.32.713-.713.713H7.92a.713.713 0 0 1-.714-.713v-5.708",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M7.683 6.518c.394 0 2.033 4.048 4.28 4.28l-.237 2.617H8.872l-1.665 7.372c0 .394-3.648.713-4.042.713a.713.713 0 0 1-.714-.713V8.42c0-.394 4.838-1.903 5.232-1.903M16.244 6.518c.394 0 4.756 1.509 4.756 1.903v12.366c0 .394-.32.713-.713.713-.394 0-4.043-.32-4.043-.713l-1.665-7.372h-2.853l.237-2.616c1.427 0 3.887-4.28 4.28-4.28",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M7.683 6.518c-.131 0 0-.131 0 0-.131 0 0 .132 0 0l.748 1.19a.713.713 0 0 1 0 1.426H3.165c-.92 0-1.665-.745-1.665-1.664v-.952c0-.919.745-1.664 1.665-1.664h4.877a.713.713 0 1 1 0 1.426l-.36.238M14.696 5.567c0-.394.32-.713.713-.713h4.878c.919 0 1.664.745 1.664 1.664v.952c0 .919-.745 1.664-1.664 1.664H15.02c-.394 0-.204-.082-.204-.476 0-.394-.121-.61.204-.95l1.223-1.19c0 .132.131 0 0 0h.713-.713l-.835-.237a.713.713 0 0 1-.713-.714M1.5 20.787c0-.394.32-.714.713-.714h19.025a.713.713 0 1 1 0 1.427H2.213a.713.713 0 0 1-.713-.713",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M11.726 13.415c.394 0 .713.319.713.713v6.659a.713.713 0 1 1-1.427 0v-6.659c0-.394.32-.713.714-.713",
    clipRule: "evenodd"
  })));
};
export default SvgFeatureTopHospitalFilled;